import { FieldModel } from '@cibo/core'
import { FieldConfirmOpportunityDialog } from 'components/FieldConfirmOpportunityDialog'
import { useState } from 'react'

export const useConfirmOpportunityDialog = () => {
  const [confirmOpportunity, setConfirmOpportunity] = useState<{
    programId: string
    field: FieldModel
  }>()

  return {
    setConfirmOpportunity,
    confirmOpportunityDialog: (
      <FieldConfirmOpportunityDialog
        open={!!confirmOpportunity}
        field={confirmOpportunity?.field}
        programId={confirmOpportunity?.programId}
        onClose={() => setConfirmOpportunity(undefined)}
        maxWidth="sm"
        fullWidth
      />
    ),
  }
}
